import React from "react"
import {AdviceWrapper} from "./components/AdviceWrapper"

function App() {
  return <div>
    <AdviceWrapper />
  </div>;
}

export default App;
